// slotSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllSlots } from '../services/api';

// Async thunk to fetch all slots
export const fetchAllSlots = createAsyncThunk(
  'slots/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      // This is your API call
      const response = await getAllSlots();
      
      // Looking at your screenshot, the response itself contains data property with the slots
      console.log("API Response:", response.data.slots);
      
      // Return the array of slots directly
      // Based on your screenshot, it looks like the actual slots array is what we need
      return response.data.slots || [];
    } catch (error) {
      console.error("Error fetching slots:", error);
      return rejectWithValue(error?.response?.data || 'Something went wrong');
    }
  }
);

// Slot slice
const slotSlice = createSlice({
  name: 'slots',
  initialState: {
    data: [], // Initialize as empty array
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllSlots.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllSlots.fulfilled, (state, action) => {
        console.log("Reducer received data:", action.payload);
        state.loading = false;
        state.data = action.payload; // Store the slots array directly
        state.error = null;
      })
      .addCase(fetchAllSlots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = []; // Reset data on error
      });
  },
});

// Selector for getting all slots
export const selectAllSlots = (state) => state.slots.data;

// Selector for SlotView
export const selectSlotView = (state) => {
  // Debugging log
  console.log("State in selectSlotView:", state);
  
  // Make sure we're accessing the correct part of the state
  if (!state || !state.slots) {
    console.error("State or state.slots is undefined:", state);
    return [];
  }
  
  console.log("Slots data:", state.slots.data);
  
  // Map the slots to the format needed for SlotView
  return state.slots.data.map(slot => ({
    id: slot._id,
    name: slot.name,
    user: slot.user,
    // Add other fields as needed
  })) || [];
};

export default slotSlice.reducer;